import { DataFilters } from 'lib/types/dataFilters';

import { SET_DATA_FILTERS } from './actionTypes';
import { DataFiltersAction } from './actions';

export interface DataFiltersState extends DataFilters {}

export const initialState: DataFiltersState = {};

export default function dataFiltersReducer(
  state: DataFiltersState = initialState,
  action: DataFiltersAction,
): DataFiltersState {
  switch (action.type) {
    case SET_DATA_FILTERS:
      return { ...action.filters };

    default:
      return state;
  }
}
